// extracted by mini-css-extract-plugin
export default {"qr_box":"index_qr_box_RclsY","qr":"index_qr_QR63w","title":"index_title_NC96U","img":"index_img_CWHlK","tip":"index_tip_lZqEk","close":"index_close_ilwS5"};